import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

import MomSysCustomerSupplyOrderBuyDetailCreateDialog from './../dialogTypes/MomSysCustomerSupplyOrderBuyDetailCreateDialog';

function MomSysCustomerSupplyOrderBuyDetailCreateButton(props) {
    const { t } = useTranslation();

    const {
        id,
        onSelectMst,
        schema,
        onSuccess,
        createButtonName,
        modifyUrlCallback,
        customizeErrorMsgCallback,
        title,

        eguUglOrderBuyerDetailSelect,

        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-create-button"}
                onClick={onOpen}
                createButtonName={createButtonName}
                {...others}
            />
            <MomSysCustomerSupplyOrderBuyDetailCreateDialog
                id={id + "-create-dialog"}
                mode="create"
                formId={id + "-create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                onSelectMst={onSelectMst}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                eguUglOrderBuyerDetailSelect={eguUglOrderBuyerDetailSelect}
            />
        </>
    );
}

export default MomSysCustomerSupplyOrderBuyDetailCreateButton;
